(function () {
  if (window.lrgPredictiveSearchInitialized) return;
  window.lrgPredictiveSearchInitialized = true;

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 280;
  var DESKTOP_QUERY = '(min-width: 1024px)';
  var SUGGEST_URL =
    (window.theme && window.theme.routes && window.theme.routes.predictiveSearch) ||
    '/search/suggest';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.lrgPredictiveReady === 'true') return;
    root.dataset.lrgPredictiveReady = 'true';

    var input = root.querySelector('input[type="search"], input[name="q"], input[name="search"]');
    var results = root.querySelector('[data-lrg-predictive-results]');
    if (!input || !results) return;

    var abortController = null;
    var requestId = 0;

    function setOpen(isOpen) {
      var shouldOpen = isOpen && isDesktop();
      root.classList.toggle('is-open', shouldOpen);
      input.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      if (shouldOpen) {
        results.hidden = false;
      } else {
        results.hidden = true;
      }
    }

    function clearResults() {
      results.innerHTML = '';
      setOpen(false);
    }

    function getSearchResults(term) {
      if (!isDesktop()) {
        clearResults();
        return;
      }

      if (abortController) abortController.abort();
      abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var currentRequest = ++requestId;

      var params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '8',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search'
      });

      var fetchOptions = { credentials: 'same-origin' };
      if (abortController) fetchOptions.signal = abortController.signal;

      return fetch(SUGGEST_URL + '?' + params.toString(), fetchOptions)
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.text();
        })
        .then(function (text) {
          if (currentRequest !== requestId) return;
          if (!isDesktop()) {
            clearResults();
            return;
          }
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section =
            doc.querySelector('#shopify-section-predictive-search') ||
            doc.querySelector('.shopify-section');
          var markup = section ? section.innerHTML.trim() : '';
          if (!markup) {
            clearResults();
            return;
          }
          results.innerHTML = markup;
          setOpen(true);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          clearResults();
        });
    }

    var onInput = debounce(function () {
      if (!isDesktop()) {
        clearResults();
        return;
      }
      var term = input.value.trim();
      if (term.length < MIN_CHARS) {
        clearResults();
        return;
      }
      getSearchResults(term);
    }, DEBOUNCE_MS);

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (!isDesktop()) return;
      if (input.value.trim().length >= MIN_CHARS && results.innerHTML.trim()) {
        setOpen(true);
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        clearResults();
        input.blur();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setOpen(false);
    });

    if (window.matchMedia) {
      var desktopMedia = window.matchMedia(DESKTOP_QUERY);
      var onViewportChange = function () {
        if (!isDesktop()) clearResults();
      };
      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', onViewportChange);
      } else if (typeof desktopMedia.addListener === 'function') {
        desktopMedia.addListener(onViewportChange);
      }
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lrg-predictive-search]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
